import { Injectable } from '@angular/core';
import { IesHttpClient } from '../../../Common/ies-http-client.service';
import { AppUrl } from './../../../Common/appUrl';

@Injectable()
export class AdmManageErrorCaseService {
  constructor(private _httpClient: IesHttpClient) {}

  allowUserToReschedule(body: any) {
    return this._httpClient.post(AppUrl.allowUserToReschedule, body);
  }

  markAsComplete(body: any) {
    return this._httpClient.post(AppUrl.markAsComplete, body);
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-eligibilities/adm-manage-error-case/adm-manage-error-case.service.ts